import { api } from './apiClient';

/** Links Confirmar / Cancelar / Reagendar enviados por WhatsApp (blocos #42/#43). Públicos, sem login. */
export type AppointmentActionView = {
  status: 'PENDENTE' | 'CONFIRMADO' | 'CANCELADO';
  expired: boolean;
  canAct: boolean;
  date: string;
  start: string;
  end: string;
  modality: string | null;
  locationName: string | null;
  professionalName: string | null;
  professionalCrp: string | null;
  clinicName: string | null;
  clinicPhone: string | null;
  rescheduleUrl: string | null;
};

export type AppointmentAction = 'confirmar' | 'cancelar' | 'reagendar';

export function readAppointmentActionFromUrl(search = window.location.search): { token: string; action: AppointmentAction } | null {
  const params = new URLSearchParams(search);
  const token = params.get('consulta')?.trim();
  if (!token) return null;
  const acao = params.get('acao');
  const action: AppointmentAction = acao === 'cancelar' || acao === 'reagendar' ? acao : 'confirmar';
  return { token, action };
}

const path = (token: string, suffix = '') => `/public/appointment-actions/${encodeURIComponent(token)}${suffix}`;

export const appointmentActionsApi = {
  view: (token: string) => api.get<AppointmentActionView>(path(token), { skipAuth: true }),
  confirm: (token: string) => api.post<AppointmentActionView>(path(token, '/confirm'), undefined, { skipAuth: true }),
  cancel: (token: string, reason?: string) => api.post<AppointmentActionView>(path(token, '/cancel'), { reason }, { skipAuth: true }),
  reschedule: (token: string) => api.post<AppointmentActionView>(path(token, '/reschedule'), undefined, { skipAuth: true }),
};
